module.exports = __webpack_public_path__ + "static/media/gradients_purple.a9d598c5.PNG";